import { AuthState, SetUserPayload } from '@/global/auth/store/types'

export const setUser = (state: AuthState, { user }: SetUserPayload): void => {
  state.user = user
}
